/* eslint-disable no-console */
console.log("Hello World! (from create-block-link-externo block)");
/* eslint-enable no-console */
